import { useTranslation } from "react-i18next";

import SoftButton from "components/SoftButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

function DiscardDialog({
  open,
  handleDialogClose = Function(),
  onAccept = Function(),
  acceptButtonColor
}) {
  const { t } = useTranslation("flowDesigner");
  const handleAccept = () => {
    // Call the function passed in through props
    onAccept();
    handleDialogClose();
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="discard-dialog"
    >
      <DialogTitle id="alert-dialog-title">{t("dialogs.discard_changes.title")}</DialogTitle>
      <DialogContent>{t("dialogs.discard_changes.content")}</DialogContent>
      <DialogActions>
        <SoftButton
          className="btn-discard-dialog-cancel"
          onClick={handleDialogClose}
          variant="outlined"
          color="info"
        >
          {t("buttons.cancel")}
        </SoftButton>
        <SoftButton
          variant="contained"
          color={acceptButtonColor ? acceptButtonColor : "info"}
          onClick={handleAccept}
        >
          {t("buttons.discard")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

export default DiscardDialog;
